module.exports = __webpack_public_path__ + "static/MedalRanking2.cea50ac3.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/MedalRanking2.png
// module id = 2948
// module chunks = 0